// 51黑料 首页展示用模拟数据（虚构人物与事件，仅作版面演示）

export type Flash = {
  id: number;
  time: string;
  tag: string;
  tagColor: 'red' | 'amber' | 'ink';
  title: string;
  heat: number;
  isNew?: boolean;
};

export const flashList: Flash[] = [
  { id: 1, time: '21:40', tag: '实锤', tagColor: 'red', title: '某头部主播带货「以次充好」比对结果流出，官方口径暂未回应', heat: 982, isNew: true },
  { id: 2, time: '20:15', tag: '起底', tagColor: 'amber', title: '艺人出道前履历被逐条核对，学历与获奖经历多处存疑', heat: 876, isNew: true },
  { id: 3, time: '18:52', tag: '内幕', tagColor: 'ink', title: '多档综艺被曝剪辑倒装、按剧本走流程，现场观众证词整理', heat: 761 },
  { id: 4, time: '17:08', tag: '实锤', tagColor: 'red', title: '饭圈大额集资去向未公开明细，粉丝自发要求晒账', heat: 688 },
  { id: 5, time: '15:36', tag: '扒皮', tagColor: 'amber', title: 'MCN 合同纠纷再起：高额解约条款与分成比例被曝光', heat: 590 },
  { id: 6, time: '14:02', tag: '内幕', tagColor: 'ink', title: '头部直播间投放与「坑位费」价格表外流，业内讨论热烈', heat: 521 },
  { id: 7, time: '11:27', tag: '起底', tagColor: 'amber', title: '网红「富二代」人设被证为包装，家庭背景与说法相左', heat: 433 },
  { id: 8, time: '09:45', tag: '实锤', tagColor: 'red', title: '补税名单疑似在民间流传，涉及范围含多位商业博主', heat: 377 },
];

export type Person = {
  id: number;
  name: string;
  field: string;
  role: string;
  tags: string[];
  summary: string;
  hot: number;
};

export const peopleList: Person[] = [
  { id: 1, name: '盛迟', field: '直播带货', role: '头部主播', tags: ['以次充好', '质检比对', '同一批次'], summary: '直播间售卖的「原厂货」被指非官方正品，第三方比对结果与官方说明不一致，争议持续发酵。', hot: 982 },
  { id: 2, name: '江屿', field: '唱跳艺人', role: '综艺常驻', tags: ['剧本设定', '成团内定', '赛制争议'], summary: '从海选到成团的晋级路径被逐帧复盘，网友质疑「剧本先行」，节目方至今未公开完整赛制细则。', hot: 876 },
  { id: 3, name: '温叙', field: '饭圈经济', role: '后援会负责人', tags: ['大额集资', '晒账存疑', '去向不明'], summary: '多次应援集资累计金额不低，晒账明细存在口径反复，粉丝群体内部已出现要求第三方审计的呼声。', hot: 688 },
  { id: 4, name: '程既白', field: 'MCN 签约', role: '签约达人', tags: ['解约条款', '分成比例', '合同纠纷'], summary: '一份被披露的补充协议显示高额解约金与浮动分成并存，业内对霸王条款的讨论热度持续上升。', hot: 590 },
  { id: 5, name: '苏未晚', field: '短视频', role: '流量网红', tags: ['人设包装', '家庭背景', '前后相左'], summary: '自称「独立打拼」的主页介绍与其早年公开的家境说法存在出入，被粉丝整理出多条时间线对比。', hot: 433 },
  { id: 6, name: '陆怀瑾', field: '商业博主', role: '意见领袖', tags: ['补税传闻', '纳税明细', '口径存疑'], summary: '民间流传的一张疑似补缴名单中出现其名，本人尚未置评，讨论区要求晒出完税证明的声音渐高。', hot: 377 },
];

export type CaseItem = {
  id: number;
  title: string;
  field: string;
  points: string[];
  status: '实锤' | '跟进中';
  date: string;
  hot: number;
};

export const caseList: CaseItem[] = [
  {
    id: 1,
    title: '带货质检「以次充好」事件',
    field: '直播 / 商品质量',
    points: ['第三方抽检与官方宣传不符', '同批次生产记录前后矛盾', '品牌方与主播口径不一'],
    status: '实锤',
    date: '2026-09-03',
    hot: 982,
  },
  {
    id: 2,
    title: '综艺赛制「剧本内定」疑云',
    field: '综艺 / 赛制',
    points: ['晋级路径被逐帧复盘', '现场观众证词相互印证', '投票数据口径被反复修改'],
    status: '跟进中',
    date: '2026-08-30',
    hot: 861,
  },
  {
    id: 3,
    title: '饭圈集资晒账争议',
    field: '饭圈 / 资金',
    points: ['累计金额与披露金额有出入', '结算口径多次调整', '第三方审计诉求被搁置'],
    status: '实锤',
    date: '2026-08-26',
    hot: 744,
  },
  {
    id: 4,
    title: 'MCN 高额解约条款风波',
    field: 'MCN / 合同',
    points: ['解约金与签约金严重失衡', '分成比例浮动区间存疑', '行业同款模板被集中曝光'],
    status: '跟进中',
    date: '2026-08-21',
    hot: 629,
  },
  {
    id: 5,
    title: '网红「富二代」人设翻车',
    field: '短视频 / 人设',
    points: ['早年公开信息被翻出', '主页介绍与事实相左', '已有多位同框者出面澄清'],
    status: '实锤',
    date: '2026-08-15',
    hot: 517,
  },
];

export type Category = {
  id: number;
  label: string;
  desc: string;
  count: number;
  today: number;
};

export const personCategories: Category[] = [
  { id: 1, label: '艺人', desc: '唱跳 / 演员 / 综艺常驻的起底档案', count: 128, today: 6 },
  { id: 2, label: '主播', desc: '带货 / 连麦 / 达人的翻车实录', count: 96, today: 5 },
  { id: 3, label: '网红', desc: '短视频博主的台前幕后拆解', count: 142, today: 7 },
  { id: 4, label: '商业人物', desc: '博主 / 创业者 / 意见领袖的动态', count: 74, today: 3 },
];

export const caseCategories: Category[] = [
  { id: 1, label: '直播带货', desc: '质检、翻车、售后争议专题', count: 108, today: 4 },
  { id: 2, label: '综艺赛制', desc: '剧本、剪辑、投票内幕梳理', count: 63, today: 2 },
  { id: 3, label: '饭圈经济', desc: '集资、应援、代拍账目追踪', count: 87, today: 5 },
  { id: 4, label: '商业纠纷', desc: '合同、股权、税务争议归档', count: 51, today: 3 },
];

export type FaqItem = {
  q: string;
  a: string;
};

export const faqList: FaqItem[] = [
  {
    q: '「实锤」「起底」「内幕」分别代表什么可信度？',
    a: '「实锤」指已有图片、录音、单据或比对结果等多方证据相互印证的内容；「起底」是对某人的公开履历、经历进行时间线还原；「内幕」多为单一信源或侧面证据，仅作线索留存，严谨程度低于前两者。',
  },
  {
    q: '内容里的信息可靠吗？会不会误伤？',
    a: '本站对每个事件都会附上证据来源与核对过程，标注「跟进中」的条目会随新证据持续更新。若涉及不实信息，当事人可联系提交更正，核实后我们会同步修正并注明勘误。',
  },
  {
    q: '如何区分「实锤」与仍在发酵的传闻？',
    a: '实锤条目右下角带红色盖章角标；仍在核实的条目标注「跟进中」并使用琥珀色时间线，读者可按颜色快速分流判断可信度。',
  },
  {
    q: '我能投稿线索或补充证据吗？',
    a: '可以。页面底部「线索征集」接受文字、截图与材料说明，整理组会做信源交叉验证。出于隐私保护，仅记录内容不记录个人联系方式之外的信息。',
  },
  {
    q: '为什么有的内容人物与事件被打了码或脱敏？',
    a: '为避免二次误伤与隐私滥用，涉及个人隐私、未成年人或尚在司法程序中的内容会做脱敏处理，仅呈现可被公开证据支撑的部分。',
  },
];

export type TopicStat = {
  id: number;
  label: string;
  value: number;
  trend: number;
};

export const topicStats: TopicStat[] = [
  { id: 1, label: '今日新增条目', value: 128, trend: 12 },
  { id: 2, label: '进行中专题', value: 36, trend: 4 },
  { id: 3, label: '已核实实锤', value: 521, trend: 18 },
  { id: 4, label: '累计归档线索', value: 3847, trend: 9 },
];